export function batch(callback) {
  let calls = [];
  return (...args) => {
    if (calls.length === 0) {
      window.setTimeout(() => {
        callback(calls);
        calls = [];
      });
      calls = [];
    }
    calls.push(args);
  };
}
export function batchByKey(callback) {
  const calls = {};
  return (key, ...args) => {
    if (!calls[key]) {
      window.setTimeout(() => {
        callback(key, calls[key]);
        delete calls[key];
      });
      calls[key] = [];
    }
    calls[key].push(args);
  };
}